export default "__VITE_ASSET__B9lmB$5l__"